import React from "react";
import { Link } from "react-router-dom";
import ConfiguracionSection from "../TransferenciasMotorPage/ConfiguracionSection";

export function TransferenciasConfigPage() {
  return (
    <div>
      <div className="flex items-center gap-4 mb-4">
        <h1 className="text-xl font-bold text-gray-800">
          Configuración de Transferencias
        </h1>
        <Link
          to="/inteligencia-negocios/transferencias"
          className="text-sm text-purple hover:underline"
        >
          ← Volver al Motor
        </Link>
      </div>
      <ConfiguracionSection />
    </div>
  );
}

export default TransferenciasConfigPage;
